module.exports = __webpack_public_path__ + "img/relieved_face.5dc13a98.gif";